import { RoutersPrincipal } from "./routers/RoutersPrincipal";

function App() {
  return (
    <div>
      <RoutersPrincipal />
    </div>
  );
}

export default App;
